<template>
<div id="recuperaciones_ws">
  <div>
    <v-breadcrumbs :items="breadcrumbs">
      <v-icon slot="divider">forward</v-icon>
    </v-breadcrumbs>
  </div>

  <v-container fluid fill-height>
    <v-row align-center justify-center>
      <v-col sm="12">
        <base-material-card color="primary" icon="library_books" title="Recuperaciones por Patente" class="elevation-1 px-5 py-3">

          <br />
          <v-card-actions>

            <v-spacer></v-spacer>
            <v-btn small fab dark color="red" @click="modal_recuperacion= !modal_recuperacion" :loading="loading" title="Reintentar Recuperaciones" v-tippy>
              <v-icon>reply_all</v-icon>
            </v-btn>
            <v-btn small fab rounded color="red" @click=" dialog1 = true" title="Generar por Pedimento" v-tippy>
              <v-icon>list</v-icon>
            </v-btn>
          </v-card-actions>
          <v-tabs grow style="margin-bottom: 30px;">
            <v-tabs-slider color="primary"></v-tabs-slider>
            <v-tab :key="'in-view'">Generar Consulta</v-tab>
            <v-tab :key="'in-report'">Consultas Programadas</v-tab>

            <v-tab-item :key="'in-view'">
              <v-card-text>
                <v-card-title>
                  <span class="headline"></span>
                </v-card-title>
                <v-form ref="form1" lazy-validation>
                  <v-container grid-list-md text-xs-center>
                    <v-row>
                      <v-col cols="11" sm="5">
                        <v-autocomplete item-value="id" item-text="text" chips small-chips no-data-text="No se localizaron sellos de patentes" :items="patentes" v-model="patente" label="Patente" :hide-no-data="false" :rules="[rules.required]">
                        </v-autocomplete>

                      </v-col>
                      <v-col cols="11" sm="5">

                      </v-col>
                    </v-row>
                    <v-row row wrap>
                      <v-col sm="12" md="6" lg="6">

                        <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                          <template v-slot:activator="{ on }">
                            <v-text-field v-on="on" v-model="model.fecha_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="
                                                                        model.fecha_de = parseDate(model.fecha_de)
                                                                        " v-mask="'####-##-##'" :rules="[
                                                                        rules.required,
                                                                        validaDias,
                                                                        validaFecha,
                                                                        ]">
                            </v-text-field>
                          </template>

                          <v-date-picker v-model="model.fecha_de" color="secondary" landscape scrollable locale="es-mx" @input="menu1 = false">
                            <v-spacer />

                            <v-btn color="secondary" large @click="menu1 = false">
                              Cancelar
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col sm="12" md="6" lg="6">
                        <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                          <template v-slot:activator="{ on }">
                            <v-text-field v-on="on" v-model="model.fecha_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="model.fecha_a = parseDate(model.fecha_a)" v-mask="'####-##-##'" :rules="[
                                                            rules.required,
                                                            validaDias,
                                                            validaFecha,
                                                            ]"></v-text-field>
                          </template>
                          <v-date-picker v-model="model.fecha_a" color="secondary" landscape scrollable locale="es-mx" @input="menu2 = false">
                            <v-spacer />

                            <v-btn color="secondary" large @click="menu2 = false">
                              Cancelar
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                      </v-col>
                    </v-row>
                  </v-container>
                  <v-card-actions>

                    <v-btn v-if="datanorecuperados.length > 0 " rounded color="red" @click="crearproceso" :loading="loading">
                      <v-icon>done</v-icon>Enviar Recuperar
                    </v-btn>
                    <v-spacer></v-spacer>

                    <v-btn rounded color="success" @click="vistaprevia()" :loading="loading">
                      <v-icon>done</v-icon>Vista Previa
                    </v-btn>
                  </v-card-actions>
                </v-form>

              </v-card-text>

              <v-card-text>
                <v-client-table ref="table_vista" :data="data_view.datos" :columns="data_view.columns" :options="data_view.options" class="elevation-2 pa-2 scroll-table">
                  <template slot="noResults">
                    <v-alert :value="true" icon="info" color="info">No se encontro ningun registro</v-alert>
                  </template>

                  <template slot="actions" slot-scope="props">

                    <v-btn x-small fab dark color="orange" @click="mostrarErroresRecuperacion(props.row)" title="Errores de Recuperación" v-tippy>
                      <v-icon>report</v-icon>
                    </v-btn>
                  </template>
                </v-client-table>
              </v-card-text>
            </v-tab-item>
            <v-dialog v-model="dialog1" max-width="500px">
              <v-card>
                <v-card-text>
                  <h5>Ingrese lista de Pedimentos</h5>
                  <v-textarea outlined rows="15" v-model="listado"></v-textarea>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn small @click="listado=''; dialog1 = false">Cancelar</v-btn>
                  <v-btn small color="primary" @click="buscar_pedimentos(); dialog1 = false">Procesar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-tab-item :key="'in-report'">
              <v-card-actions>
                <v-refresh-button :funcion="cargar" />
                <v-spacer></v-spacer>

              </v-card-actions>
              <v-card-text>

                <v-client-table ref="principalTable" :data="datos" :columns="columns" :options="options" class="elevation-2 pa-2">
                  <template slot="noResults">
                    <v-alert :value="true" icon="info" color="info">No se encontro ningun registro</v-alert>
                  </template>

                  <template slot="detail" slot-scope="props">
                    <!-- <v-btn icon color="primary" title="Mostrar Archivos" @click="showDetail(props.row)">
                                            <v-icon v-if="registro_seleccionado != props.row.id">add_circle</v-icon>
                                            <v-icon v-if="registro_seleccionado == props.row.id">remove_circle</v-icon>
                                        </v-btn> -->
                    <exportar-excel v-tippy style="cursor: pointer" title="Exportar" :data="[]" :exportFields="headersExcel" name="DetalleConsulta.xlsx" :funcion="get_detalle_solicitud(props.row.id)">
                      <v-btn fab x-small dark color="success" title="Exportar" v-tippy>
                        <v-icon dark>get_app</v-icon>
                      </v-btn>
                    </exportar-excel>
                  </template>
                  <template slot="actions" slot-scope="props">
                    <v-btn text icon color="primary" title="Descargar" v-if="props.row.estatus=='Generado Correctamente' && props.row.filename!='' " @click="downloadReporte(props.row.filename)">
                      <v-icon dark>get_app</v-icon>
                    </v-btn>
                    <v-btn text icon color="red" title="Eliminar" v-if="permisoEliminar" @click="eliminar(props.row.id)">
                      <v-icon dark>delete</v-icon>
                    </v-btn>
                  </template>

                  <template slot="child_row">
                    <v-toolbar dense height="35pt">
                      <v-toolbar-title><span style="font-size:12pt">Archivos:</span></v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                      <div class="row">
                        <v-spacer></v-spacer>
                        <div class="col-xs-1">
                          <exportar-excel :data="dias.items" :exportFields="dias.camposexcel" :name="'ConsultaPatente' + registro_seleccionado + '.xlsx'">
                            <v-btn fab dark small color="success" title="Exportar" v-tippy>
                              <v-icon dark>get_app</v-icon>
                            </v-btn>
                          </exportar-excel>

                        </div>
                      </div>
                      <div class="row">
                        <div class="col-xs-10"></div>
                      </div>
                      <v-client-table ref="detailtable" :data="dias.items" :columns="columnsDias" :options="optionsDias" class="elevation-2 pa-2">
                        <template slot="noResults">
                          <v-alert :value="true" icon="info" color="info">No se encontró ningún registro</v-alert>
                        </template>

                      </v-client-table>
                    </v-card-text>
                    <hr>

                  </template>
                </v-client-table>
              </v-card-text>
            </v-tab-item>

          </v-tabs>

        </base-material-card>
      </v-col>
    </v-row>
  </v-container>

  <v-dialog v-model="modalErroresRecuperacion" min-width="50%" max-width="70%">
    <v-card>
      <v-card-title>
        <v-card class="primary white--text titulomodal">
          <v-icon @click.native="modalErroresRecuperacion = false" class="white--text">cancel</v-icon>&nbsp;
          <span class="subheading">
            <strong>Errores de Recuperación Webservice</strong>
          </span>
        </v-card>
      </v-card-title>
      <v-card-text>
        <h5>Intentos de Recuperación: {{intentosRecuperacion}} </h5>
        <span>{{ mensajeErrores }}</span>

        <v-client-table ref="vuetableErroresRecuperacion" :data="errores" :columns="errores_columns" :options="errores_options" class="elevation-2 pa-2 scroll-table">
          <template slot="noResults">
            <v-alert :value="true" icon="info" color="info">No se encontró ningun registro</v-alert>
          </template>
        </v-client-table>

      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn small @click="modalErroresRecuperacion = false">Cerrar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="modal_recuperacion" max-width="500px" persistent>
    <v-card>
      <v-card-text>
        <h5><b>Reintentar Recuperaciones</b></h5>
        <span>Todos los archivos con estatus de error y no recuperables se enviarán a recuperar nuevamente. Este proceso podría tardar días dependiendo del total de sus archivos.</span>
        <v-form ref="form_masivo" lazy-validation style="margin-top: 10px;" >
          <v-container grid-list-md text-xs-center>
            <v-row row wrap>
              <v-col>

                <v-menu ref="menu5" v-model="menu5" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                  <template v-slot:activator="{ on }" >
                    <v-text-field v-on="on" v-model="model_recuperacion.fecha_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="model_recuperacion.fecha_de = parseDate(model_recuperacion.fecha_de)" v-mask="'####-##-##'" :rules="[
                                                                        rules.required,
                                                                        validaDias,
                                                                        validaFecha,
                                                                        ]" />
                  </template>

                  <v-date-picker v-model="model_recuperacion.fecha_de" color="secondary" landscape scrollable locale="es-mx" @input="menu5 = false" >
                    <v-spacer />

                    <v-btn color="secondary" large @click="menu5 = false" >
                      Cancelar
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col>
                <v-menu ref="menu6" v-model="menu6" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                  <template v-slot:activator="{ on }" >
                    <v-text-field v-on="on" v-model="model_recuperacion.fecha_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="model_recuperacion.fecha_a= parseDate(model_recuperacion.fecha_a)" v-mask="'####-##-##'"
                        :rules="[rules.required, validaDias, validaFecha]" ></v-text-field>
                  </template>
                  <v-date-picker v-model="model_recuperacion.fecha_a" color="secondary" landscape scrollable locale="es-mx" @input="menu6 = false" >
                    <v-spacer />

                    <v-btn color="secondary" large @click="menu6 = false" >
                      Cancelar
                    </v-btn>
                  </v-date-picker>
                </v-menu>

              </v-col>
            </v-row>
            <v-row row wrap>
              <v-row>
                <v-col>
                  <v-combobox v-model="model_recuperacion.patentes" :items="patentes" label="Patentes" multiple chips :rules="[rules.required]" ></v-combobox>
                </v-col>
              </v-row>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn small @click="modal_recuperacion = false" >Cancelar</v-btn>
        <v-btn small color="primary" @click="genera_recuperacion" >Enviar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import RefreshButton from "@/components/RefreshButton.vue";

export default {
  components: {
    "v-refresh-button": RefreshButton,
  },
  created: function() {
    this.URL = this.$hostname;
    this.loading = false;
    this.model.usuario = this.$local_storage.get("id_usuario");
    this.model.rfc = this.$local_storage.get("rfc");
    var tipoUsuario = this.$local_storage.get("tipo_usuario");
    if (tipoUsuario == "Soporte" || tipoUsuario == "Super Usuario")
      this.permisoEliminar = true;
    this.cargarErrores();
    this.getPatentes();
  },
  data: () => ({
    headersExcel: {
      "No Pedimento": "no_pedimento",
      "Archivo": "archivo",
      "Tipo": "tipo",
      "Estatus": "estatus",
      "Fecha": "fecha",
      "Error": "error"
    },
    registro_seleccionado: '',
    mes: "",
    listado: "",
    dialog1: false,
    menu: false,
    menu1: false,
    menu2: false,
    patente: "",
    patentes: [],
    to_download: [],
    emisores: [],
    norecuperados: true,
    emisor_seleccionado: "",
    allChecked: false,
    permisoEliminar: false,
    tab: null,
    lista_filtrada: [],
    lista_filtrada_acuses: [],
    errores_ws: [],
    errores: [],
    errores_columns: ["fecha", "error"],
    errores_options: {
      filterable: ["fecha", "error"],
      sortable: ["fecha", "error"],
    },
    modalErroresRecuperacion: false,
    intentosRecuperacion: 0,
    mensajeErrores: '',
    breadcrumbs: [{
        text: "Inicio",
        disabled: false,
        to: "/home"
      },
      {
          text: "E-Drive",
          disabled: true,
          to: ""
      },
      {
        text: "Recuperaciones por Patente",
        disabled: true,
        to: ""
      }
    ],

    dialog1: false,
    dialog2: false,
    modal_recuperacion: false,
    modal_acuses: false,
    modal_emisores: false,
    dialogListado: false,
    listado: "",
    dias: {
      items: [],
      camposexcel: {
        "Pedimento": "no_pedimento",
        "Archivo": "archivo",
        "Tipo": "tipo",
        "Fecha Actualización": "fecha",
        "Estatus": "estatus",
        "Error": "error"

      },
    },
    columnsDias: [

      "no_pedimento",
      "archivo",
      "tipo",
      "fecha",
      "estatus",
      "error"
    ],
    optionsDias: {
      filterable: [
        "no_pedimento",
        "archivo",
        "tipo",
        "fecha",
        "error",
      ],
      sortable: [
        "no_pedimento",
        "archivo",
        "tipo",
        "fecha",
        "error",
      ],
      orderBy: {
        column: 'fecha',
        ascending: false
      },
      headings: {
        "no_pedimento": "Pedimento",
        "archivo": "Archivo",
        "tipo": "Tipo",
        "fecha": "Fecha",
        "estatus": "Estatus",
        "error": "Error"
      },
    },
    datos: [],
    columns: ["detail", "fecha", "patente", "descripcion", "total", "recuperados", "fallidos", "pendientes", "avance", "estatus", "actions"],
    options: {
      filterable: ["fecha", "patente", "descripcion", "estatus", ],
      sortable: ["fecha", "patente", "descripcion", "estatus", ],
      orderBy: {
        column: 'id',
        ascending: false
      },
      headings: {
        detail: '',
        fecha: "Solicitado",
        patente: "Patente",
        descripcion: "Descripción",
        estatus: "Estatus",
        total: "Total Archivos",
        recuperados: "Procesados",
        fallidos: "Fallidos",
        pendientes: "Pendientes",
        avance: "% Avance",
        actions: "Operaciones"
      },
      uniqueKey: "id",
    },
    loading: true,
    show_loading: true,
    acuses: [],
    model: {
      rfc: "",
      usuario: "",
      pedimento: "",
      fecha_de: "",
      fecha_a: "",
      reporte_url: "/reportes_vucem/recuperaciones_ws/",
      nombre_reporte: "Recuperaciones WS",
      tipo: "Recuperaciones WS",
      tipo_reporte: "",
      norecuperados: 0,
      archivo: "", //para buscar por nombre de archivo (pedimento|cove|edocument)
    },
    model_recuperacion: {
      rfc: '',
      fecha_de: '',
      fecha_a: '',
      patentes: [],
    },
    model_acuses: {
      id_documento: "",
      edocument: "",
      emisor: "",
    },
    menu1: false,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
    rules: {
      required: v => !!v || "Este campo es requerido",
      numeric: value => {
        const pattern = /^[\d]*$/;
        return pattern.test(value) || "Solo se permiten números";
      }
    },
    data_view: {
      datos: [],
      columns: ['id_pedimento', 'no_pedimento', 'clave_documento', 'tipo_operacion', 'tipo_pedimento', 'fecha_pedimento',
        'tipo', 'archivo', 'estatus', //'ext', 'estado', 'subestado',
        'fecha_actualizacion', "actions"
      ],
      options: {
        filterable: ['no_pedimento', 'clave_documento', 'tipo_operacion', 'tipo_pedimento', 'fecha_pedimento',
          'tipo', 'archivo', 'estatus', // 'ext', 'estado', 'subestado',
          'fecha_actualizacion'
        ],
        sortable: ['no_pedimento', 'clave_documento', 'tipo_operacion', 'tipo_pedimento', 'fecha_pedimento',
          'tipo', 'archivo', 'estatus', //'ext', 'estado', 'subestado',
          'fecha_actualizacion'
        ],

        headings: {
          id_pedimento: '',
          no_pedimento: 'No. Pedimento',
          'clave_documento': "Clave Documento",
          'tipo_operacion': "Tipo Operación",
          'tipo_pedimento': "Tipo Pedimento",
          fecha_pedimento: 'Fecha Pedimento',
          // fecha_estado:'Fecha Estado',
          //  estado:'Estado',
          //  subestado:'Subestado',
          tipo: 'Tipo',
          archivo: 'Archivo',
          //  ext:'Extensión',
          estatus: 'Estatus',

          fecha_actualizacion: 'Fecha Actualización',
          total: 'Total Archivos',
          recuperados: 'Recuperados',
          fallidos: 'Fallidos',
          pendientes: 'Pendientes',
          actions: 'Operaciones'
        }
      }
    }
  }),
  computed: {
    datanorecuperados() {
      let result = [];
      if (this.$refs.table_vista != null) {
        return this.$refs.table_vista.allFilteredData;
      } else {
        return this.data_view.datos;
      }

    },
    superusuario() {
      return this.$local_storage.get("tipo_usuario") == "Super Usuario";
    },

  },
  methods: {
    buscar_pedimentos: function() {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      this.active = [];

      if (this.listado.split("\n").length == 0) {
        this.$root.$dialogLoader.hide();
        this.$swal({
          type: "error",
          title: "¡Operación no Permitida!",
          text: 'Al menos debe existir un elemento en la lista',
          footer: '',
        });

        return false;
      }

      var data = {
        rfc: this.$local_storage.get("rfc"),
        "anio": 0,
        "mes": 0,
        "pedimentos": this.listado.split("\n"),
        "id_usuario": this.$local_storage.get("id_usuario")
      };

      axios
        .post(this.$hostname + "vucem/solicitud_agente_pedimentos/", data)
        .then(res => {

          this.$root.$dialogLoader.hide();
          this.listado = "";
          this.$swal({
            type: "success",
            title: "¡Operación Existosa!",
            text: "La lista se envió correctamente en breve aparecerán las consultas programadas de aquellas patentes que cuenten con sus sellos.",
            footer: ""
          });
        })
        .catch(err => {
          this.$root.$dialogLoader.hide();
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al consultar la lista verifique la información y vuelva a intentarlo",
            footer: ""
          });
          console.log(err);
        });

    },
    getNumeroPatente: function(id) {

      let encontrada = this.patentes.find(e => e.id == id);
      if (encontrada != undefined)
        return encontrada.text;
      else
        return "";
    },
    getPatentes: function() {
      let self = this;
      var data = {
        cliente: this.$local_storage.get("rfc"),
        headers: {
          "Content-type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "cache-control": "no-cache"
        }
      };
      axios
        .post(
          this.$hostname + "catalogos/certificados/list_certificados_agentes/",
          data
        )
        .then(res => {
          if (typeof res.data !== "undefined") {
            res.data.forEach(function(r) {
              self.patentes.push({
                "id": r.id,
                "text": r.patente + "-" + r.curp
              });

            });
          }
        })
        .catch(err => {

          console.log(err);
        });
    },
    eliminar: function(idreporte) {
      this.$swal({
        type: "info",
        title: "Cuidado",
        text: "¿Está seguro de eliminar el reporte con No. Proceso: " + idreporte + "?",
        footer: "",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar"
      }).then(result => {
        if (result.value) {
          this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
          var datos = {
            id: idreporte,
          }
          axios.post(this.$hostname + 'vucem/delete_solicitud_agente/', datos)
            .then((res) => {
              this.$swal({
                type: "success",
                title: "Operación Exitosa",
                text: "El proceso se eliminó correctamente",
                footer: ""
              });
            })
            .catch((error) => {
              this.$swal({
                type: "error",
                title: "¡Operación no Permitida!",
                text: "Ocurrió un error al eliminar el proceso. Favor de comunicarse con soporte.",
                footer: '',
              });
              console.log(error);
            }).then(() => {
              this.$root.$dialogLoader.hide();
              this.cargar();
            });
        }
      });
    },
    cargar: function() {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      let data = {
        rfc: this.model.rfc,
        tipo: this.model.tipo
      };
      axios.post(this.URL + "vucem/list_solicitudes_agente/", data)
        .then(res => {
          if (typeof res.data !== "undefined") {
            this.datos = res.data;

            for (var k in this.datos) {

              this.datos[k].fecha = this.parseDate(this.datos[k].fecha);
              this.datos[k].estatus = this.getEstatus(this.datos[k].estatus);
              this.datos[k].patente = this.getNumeroPatente(this.datos[k].id_certificado_agente);
              this.datos[k].mes = this.getMes(this.datos[k].mes);
              // let archivos = this.datos[k].archivos;
              this.datos[k].total = this.datos[k].total;
              this.datos[k].recuperados = this.datos[k].recuperados;
              this.datos[k].fallidos = this.datos[k].fallidos;
              this.datos[k].pendientes = this.datos[k].pendientes;
              // let avance = parseInt((this.datos[k].fallidos + this.datos[k].recuperados) / this.datos[k].total * 100);
              let avance = this.datos[k].avance = "% " + this.datos[k].avance;
              if (avance > 0 && avance < 100)
                this.datos[k].estatus = this.getEstatus(3);
              else
                this.datos[k].estatus = this.getEstatus(this.datos[k].estatus);
            }
          }
        })
        .catch(err => {
          console.log(err);
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    getEstatus: function(estatus) {
      var arr_estatus = ["Pendiente", "Procesado", "Fallido", "En Proceso"];
      if (estatus in arr_estatus)
        return arr_estatus[estatus];
      else
        return estatus;
    },
    getMes: function(mes) {
      var arr_estatus = ["", "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
      if (mes in arr_estatus)
        return arr_estatus[mes];
      else
        return mes;
    },
    removerLineasVacias(listado) {
      var listadoSplit = this.listado.split("\n");
      var listadoSinEspacios = listadoSplit.filter(item => {
        return item.trim() != "";
      });
      return listadoSinEspacios;
    },
    vistaprevia: function(opcion = 0) {
      if (!this.$refs.form1.validate() && opcion == 0) { //Opción sirve para saltar la validación cuando se busca por listado
        //Alguna operación o mensaje
      } else {
        let self = this;

        let patente_arreglo = self.getNumeroPatente(self.patente).split("-");
        let patente_actual = patente_arreglo[0];
        let curp_patente = patente_arreglo[1];



        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        var data = this.model;
        data["lista"] = this.removerLineasVacias(this.listado);
        if (data.pedimento == '') delete(data['pedimento']);
        if (data.fecha_de == '') delete(data['fecha_de']);
        if (data.fecha_a == '') delete(data['fecha_a']);
        if (data.archivo == '') delete(data['archivo']);

        data.tipo_reporte = 3;


        axios({
            method: "post",
            url: this.$hostname + "reportes_vucem/recuperaciones_ws_preview/",
            data: data
          })
          .then(response => {
            this.to_download = [];
            this.data_view.datos = response.data;
            this.data_view.datos = this.data_view.datos.filter(
              r =>
              (r.estatus == 'ERROR' || r.estatus == 'NO RECUPERABLE' || r.estatus == 'PENDIENTE AA') &&
              (r.tipo == 'XML COVE' || r.tipo == 'XML EDOCUMENT' || r.tipo == 'XML REMESA' ||
                r.tipo == 'PDF ACUSE COVE' || r.tipo == 'PDF ACUSE EDOCUMENT' || r.tipo == 'PDF ACUSE REMESA') &&
              r.no_pedimento.split("-")[1] == patente_actual && r.curp_agente == curp_patente);

            for (var k in this.data_view.datos) {
              this.data_view.datos[k].error = this.getErrorWS(this.data_view.datos[k].error);
            }
          })
          .catch(error => {
            let mensaje;
            if (typeof error.response !== "undefined") {
              mensaje = error.response.data.mensaje;
            } else {
              mensaje = "Reporte demasiado grande para vista previa. Intenta con un periodo más corto";
            }

            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: mensaje,
              footer: ""
            });
          }).then(() => {
            this.listado = "";
            this.model.archivo = '';
            this.lista_filtrada = [];
            this.model.lista = '';
            this.$root.$dialogLoader.hide();
          });
      }

    },
    getTipo: function(id) {

      if (id == 7)
        return "XML COVE";
      if (id == 10)
        return "PDF ACUSE COVE";
      if (id == 11)
        return "XML EDOCUMENT";
      if (id == 14)
        return "PDF ACUSE EDOCUMENT";
      if (id == 15)
        return "XML REMESA";
      if (id == 18)
        return "PDF ACUSE REMESA";

      return id;
    },

    parseDate(date) {
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD");
    },
    parseDateTime(date) {
      //Formato  YYYY-MM-DD
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD HH:mm:ss");
    },
    clear_values() {
      this.model.pedimento = '';
      this.model.fecha_de = '';
      this.model.fecha_a = '';
      this.model.archivo = '';
      this.listado = "";
    },
    base64ToArrayBuffer: function(base64) {
      var binaryString = window.atob(base64);
      var binaryLen = binaryString.length;
      var bytes = new Uint8Array(binaryLen);
      for (var i = 0; i < binaryLen; i++) {
        var ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
      }
      return bytes;
    },

    showDetail: function(row) {
      if (this.registro_seleccionado != row.id) {
        this.registro_seleccionado = row.id;
        this.cargarDias();
        var detallesAbiertos = this.$refs.principalTable.openChildRows;
        for (var k in detallesAbiertos) { //Cerramos detalles abiertos
          if (detallesAbiertos[k] != row.id)
            this.$refs.principalTable.toggleChildRow(detallesAbiertos[k]);
        }
      } else { //Significa que dio clic en '-' solo cerramos el detalle y no hacemos nada
        this.registro_seleccionado = '';
      }
      this.$refs.principalTable.toggleChildRow(row.id); //Mostramos detalle seleccionado

    },
    cargarDias: function() {
      let self = this;
      let encontrada = self.datos.find(e => e.id == self.registro_seleccionado);
      this.dias.items = encontrada.archivos;
      for (var k in this.dias.items) {
        this.dias.items[k].fecha = this.parseDate(this.dias.items[k].fecha);
        this.dias.items[k].estatus = this.getEstatus(this.dias.items[k].estatus);
        this.dias.items[k].tipo = this.getTipo(this.dias.items[k].tipo);
        this.dias.items[k].error = this.getErrorWS(this.dias.items[k].error);

      }

    },
    mostrarErroresRecuperacion: function(row) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var datos = {
        id_pedimento: row.id_pedimento,
        tipo: row.tipo_validacion,
        filename: row.archivo
      }
      axios.post(this.$hostname + 'reportes_vucem/recuperaciones_ws_errores/', datos)
        .then((res) => {
          this.errores = res.data;

          for (var k in this.errores) {
            this.errores[k].fecha = this.parseDate(this.errores[k].fecha);
            this.errores[k].error = this.getErrorWS(this.errores[k].error);
          }
          var countErrores = this.errores.length;
          this.intentosRecuperacion = countErrores;
          if (row.estatus == "NO RECUPERABLE" || row.estatus == "RECUPERADO" || row.estatus == "TOKEN INCORRECTO" || row.estatus == "EDOCUMENT PROGRAMADO")
            this.intentosRecuperacion += 1;
          this.mensajeErrores = "Se encontraron " + countErrores + " errores de recuperación para el archivo '" + row.archivo + "' que es un " + row.tipo;
          this.modalErroresRecuperacion = true;

        })
        .catch((error) => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener errores de recuperación. Favor de comunicarse con soporte.",
            footer: '',
          });
          console.log(error);
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    downloadReporte: function(key) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var datos = {
        id: key,
        bucket: "production.econnect.ds"
      }
      axios.post(this.$hostname + 's3/download_url/', datos)
        .then((res) => {
          if (typeof res.data !== 'undefined') {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = res.data.mensaje;
            a.target = '_blank';
            a.click();
            a.parentNode.removeChild(a);

          } else {
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
              footer: '',
            });
          }
        })
        .catch((error) => {
          var mensaje = "Ocurrió un error al descargar el archivo";
          if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
            mensaje = error.response.data.mensaje;
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: mensaje,
            footer: '',
          });
          console.log(error);
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    cargarErrores: function() {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      axios.get(this.$hostname + "catalogos/errores_ws/")
        .then(res => {
          this.errores_ws = res.data;
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener el catálogo de errores webservice.",
            footer: ""
          });
        }).then(() => {
          this.cargar();
        });
    },
    getErrorWS: function(errorWs) {
      if (errorWs != null && errorWs.toString().trim() != "") {
        var filter = this.errores_ws.filter(function(e) {
          return e.error.toString().trim().toLowerCase() == errorWs.toString().trim().toLowerCase();
        });
        if (filter.length > 0) {
          return filter[0].metadato;
        } else
          return errorWs;
      } else
        return errorWs;

    },
    validaFecha: function(fecha) {
      if (fecha == "Invalid date") return "Fecha no válida.";
      else return true;
    },
    validaAnio: function() {
      if (this.model.fecha_de != "" && this.model.fecha_a != "") {
        var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
        var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
        var diferencia = fin.diff(inicio, "days");
        if (diferencia < 0)
          return "La Fecha Final no debe ser menor a la Fecha Inicial.";
      }
      return true;
    },
    validaDias: function() {
      if (this.model.fecha_de != "" && this.model.fecha_a != "") {
        var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
        var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
        var diferencia = fin.diff(inicio, "days");
        if (diferencia < 0)
          return "La Fecha Final no debe ser menor a la Fecha Inicial.";
        if (Math.abs(diferencia) > 31)
          return "Periodo máximo de consulta 31 dias. Favor de verificar.";
      }
      return true;
    },
    crearproceso() {
      let self = this;
      self.$swal({
        type: "info",
        title: "Confirme",
        text: "¿Desea enviar los archivos al proceso de recuperación por patente?",
        footer: "",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar"
      }).then(result => {
        if (result.value) {
          self.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

          let archivos = [];
          let tipo = 0;
          let archivo = "";

          let a = this.model.fecha_de.split("-");

          self.datanorecuperados.forEach(function(row) {

            if (row.tipo == "XML COVE") {
              tipo = 7;
              archivo = row.archivo;
            };
            if (row.tipo == "PDF ACUSE COVE") {
              tipo = 10;
              archivo = row.archivo.split("_")[1];
            };
            if (row.tipo == "XML EDOCUMENT") {
              tipo = 11;
              archivo = row.archivo;
            };
            if (row.tipo == "PDF ACUSE EDOCUMENT") {
              tipo = 14;
              archivo = row.archivo.split("_")[1];
            };
            if (row.tipo == "XML REMESA") {
              tipo = 15;
              archivo = row.archivo;
            };
            if (row.tipo == "PDF ACUSE REMESA") {
              tipo = 18;
              archivo = row.archivo.split("_")[1];
            };

            archivos.push({
              "id_pedimento": row.id_pedimento,
              "no_pedimento": row.no_pedimento,
              "archivo": archivo,
              "tipo": tipo
            });

          });
          let data = {

            "id_certificado_agente": self.patente,
            "rfc": self.model.rfc,
            "anio": parseInt(a[0]),
            "mes": parseInt(a[1]),
            "archivos": archivos,
            "id_usuario": this.model.usuario,
            "descripcion": "De " + this.model.fecha_de + " a " + this.model.fecha_a

          };

          axios.post(self.$hostname + "vucem/solicitud_agente/", data)
            .then(res => {
              this.$swal({
                type: "success",
                title: "¡Operación exitosa!",
                text: "El proceso se envió correctamente",
                footer: ""
              });
              self.cargar();
            })
            .catch(err => {
              self.$root.$dialogLoader.hide();
              //Puede ser que regrese un timeout, pero igualmente se mostrará mensaje de exito
            }).then(() => {
              self.$root.$dialogLoader.hide();
            });


        }

      });

    },
    get_detalle_solicitud: function(id) {
      return async function() {
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        let data = {
          id: id
        };
        let datos = [];
        await axios.post(this.$hostname + "vucem/list_solicitudes_detalles_agente/", data)
          .then(res => {
            if (typeof res.data !== "undefined") {
              datos = res.data;
              this.$root.$dialogLoader.hide();
            }
          })
          .catch(err => {
            this.$root.$dialogLoader.hide();
            datos = []
          });
        return datos;
      }
    },
    genera_recuperacion: function() {
      if(!this.$refs.form_masivo.validate() || this.model_recuperacion.patentes.length == 0) {
        this.$swal({
                type: "info",
                title: "Información",
                text: "Debe seleccionar un rango de fechas validos y al menos una patente",
                footer: ""
              });
        return;
      }

      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

      const data = {
        "rfc": this.$local_storage.get("rfc"),
        "fecha_de": this.model_recuperacion.fecha_de,
        "fecha_a": this.model_recuperacion.fecha_a,
        "patentes": [],
        "id_usuario": this.$local_storage.get("id_usuario")
      }

      this.model_recuperacion.patentes.forEach(x => {
        data.patentes.push(x.id + "-" + x.text)
      })
      
      axios.post(this.$hostname + "vucem/solicitud_agente_masiva/", data)
            .then(res => {
              this.$swal({
                type: "success",
                title: "¡Operación exitosa!",
                text: "El proceso se envió correctamente",
                footer: ""
              });
              this.cargar();
            })
            .catch(err => {
              this.$root.$dialogLoader.hide();
            }).then(() => {
              this.$root.$dialogLoader.hide();
            });
    }
  },
};
</script>

<style scoped>
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-icon,
.theme--light.v-tabs>.v-tabs-bar .v-tab--disabled {
  color: black;
  font-size: small;
  background-color: #EEEEEE;
  padding: 0px;
}

.v-tabs .v-tabs-bar .v-tab.v-tab--active {
  color: white;
  font-size: small;
  background-color: #df7205;
  padding: 0px;
  font-weight: bold;

}

.v-tabs-slider-wrapper {
  left: 0 !important;
}

.table-bordered thead th,
.table-bordered thead td {
  font-size: xx-small !important;
}
</style>
